import React from "react";

function IconDownload(props) {
  return (
    <div className={props.className}>
        <svg
            height={props.height}
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 200 180"
            style={{verticalAlign: "bottom"}}
        >
        <path
            className={props.pathClass ? props.pathClass : "g1-fill"}
            d="M8851.51 893.277c-1.33 0-2.6.527-3.54 1.465a4.984 4.984 0 00-1.46 3.535v24.74c0 12.088 9.8 21.887 21.88 21.887h155.34c12.09 0 21.88-9.799 21.88-21.887v-24.74c0-1.326-.52-2.598-1.46-3.535a5.007 5.007 0 00-3.54-1.465h-4.58c-1.33 0-2.6.527-3.53 1.465a4.993 4.993 0 00-1.47 3.535v24.74a7.303 7.303 0 01-7.3 7.303h-155.34c-4.03 0-7.3-3.27-7.3-7.303v-24.74c0-1.326-.53-2.598-1.46-3.535a5.007 5.007 0 00-3.54-1.465h-4.58zm101.88-22.347s29.64-29.632 40.01-40.007a5.01 5.01 0 013.54-1.464c1.32 0 2.59.527 3.53 1.464 1.05 1.048 2.2 2.194 3.24 3.241.94.938 1.47 2.21 1.47 3.536s-.53 2.598-1.47 3.535l-57.61 57.611h-.04l-57.61-57.611a4.984 4.984 0 01-1.46-3.535c0-1.326.52-2.598 1.46-3.536 1.05-1.047 2.19-2.193 3.24-3.241a5.01 5.01 0 013.54-1.464c1.32 0 2.59.527 3.53 1.464 10.38 10.382 40.05 40.05 40.05 40.05V770.376c0-1.326.53-2.598 1.47-3.536a4.987 4.987 0 013.53-1.464h4.58c2.77 0 5 2.238 5 5V870.93z"
            transform="translate(-8846.51 -765.376)"
        ></path>
        </svg>
    </div>
  );
}

export default IconDownload;
